import { useEffect } from 'react'

import styles from './styles/ResearchersPanel.css'
import TalkToUs from './TalkToUs'
import PartnerValueProp from './PartnerValueProp'
import PartnersPanel from './PartnersPanel'
import AwardsAndPress from './Awards'
import PluginButton from '../misc/PluginButton'
import P from 'components/typography/Paragraph'
import * as analytics from 'lib/analytics'
import Endorsements from '../home/Endorsements'

const ResearchersPanel = () => {
  useEffect(() => {
    analytics.event({
      category: 'Partners',
      action: 'View Researchers Partners Page'
    })
  }, [])

  return (
    <div className={styles.layout}>
      <PartnerValueProp
        className={styles.valueProp}
        id='search-citations'
        header='Search research directly'
        cta='Search Citation Statements'
        ctaLocation='/search/citations'
        link='Read a case study on how we helped a researcher'
        linkLocation='https://help.scite.ai/en-us/article/how-a-research-lead-uses-scite-to-efficiently-conduct-systematic-literature-reviews-and-network-meta-analyses-5irnbp/'
      >
        <P>
          Never waste time searching for how a method, dataset, gene, organism, research result, etc. are spoken about in the literature. Search over {CONFIG.defaultCitationsTotalText} citation statements to see what experts are saying about virtually any topic.
        </P>
        <img alt='citation-statement-search' src={`${CONFIG.assetsBaseURL}/images/citation-statement-search.png`} />
      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='more-than-a-number'
        header='Understand research by seeing what is said about it in newer publications'
        cta='See example publication report'
        ctaLocation='/reports/chromosome-mis-segregation-and-cytokinesis-failure-nM3vVr'
      >
        <P>
          Quickly discover how a scientific article has been cited and if it has been supported or contrasted through Smart Citations. Smart Citations transform citations from a mere number into something that can be understood and digested on virtually any article you’re reading.
        </P>
        <img alt='report-snippet' className={styles.snippetImg} src={`${CONFIG.assetsBaseURL}/images/illustrations/report-snippet.svg?v=2`} />
      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='power-of-scite'
        header='See if a publication has been supported anywhere you’re reading online'
      >
        <P>
          The scite browser extension for Chrome, Firefox, or Safari allows you to easily see how articles have been cited anywhere you’re reading online. It’s like having hundreds of millions of pieces of evidence on virtually any topic you’re interested in available to you only a click away.
        </P>
        <img alt='plugin' src={`${CONFIG.assetsBaseURL}/images/illustrations/page-badge-snippet-2.svg?v=1`} />
        <PluginButton className={styles.plugin} />
      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='keep-track'
        illo={`${CONFIG.assetsBaseURL}/images/icons/institution-spyglass.svg`}
        header='Understand how people are citing your own work'
        cta='Get Started'
        ctaLocation='/onboarding'
      >
        <P>
          Sign up and claim your articles to see how your own work has been cited. Email alerts allow you to keep track of new citations and see if others have found evidence that supports or contrasts your work. We offer ORCID integration too for easy sign-up and syncing of your articles.
        </P>
      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='scite-cite'
        header='Stop citing retracted and heavily disputed works unintentionally'
        cta='Try Reference Check'
        ctaLocation='/?referenceCheck=true'
      >
        <P>
          Writing a research paper? The scite Reference Check allows you to easily upload your research articles to see how the references you’re citing have been cited by others. Ensure that you are citing reliable work by screening against retracted references and check to see if others have contrasted your references.
        </P>
        <img alt='reference-check' src={`${CONFIG.assetsBaseURL}/images/illustrations/reference-check.png`} />
      </PartnerValueProp>
      <PartnerValueProp
        className={styles.valueProp}
        id='improve-effeciency'
        header='Keep track of research topics and evaluate research quality'
        cta='Create research dashboards'
        ctaLocation='/create-dashboard'
      >
        <P>
          Keep track of emerging citations to trending topics and research areas with custom scite research dashboards. Get updated when a study gets supported, contrasted, or receives a new editorial notice such as retracted or withdrawn.
        </P>
        <img alt='custom-dashboard' src={`${CONFIG.assetsBaseURL}/images/illustrations/custom-dashboards.png?v=1`} />
      </PartnerValueProp>
      <PartnersPanel header='Who we’re working with' />
      <AwardsAndPress />
      <Endorsements />
      <TalkToUs />
    </div>
  )
}

export default ResearchersPanel
